<template>
  <div class="app-container">
    <el-card>
      <div class="searchTitle">
        视频生成队列：
        <div class="tags-cicle">{{ waitNum }}</div>
      </div>
      <div class="remarks">注意：请勿关闭浏览器和后台，否则排队将会取消。</div>
      <div class="table-container">
        <el-table
          v-loading="listLoading"
          :data="tableList"
          border
          style="width: 100%"
          height="68vh"
          :header-cell-style="{
            background: '#f0f0f0',
            color: '#000',
          }"
        >
          <el-table-column align="center" label="视频名称" prop="videoTitle" />
          <el-table-column align="center" label="状态" prop="contactName">
            <template #default="scope">
              <div class="flex-items">
                <div>
                  {{ scope.row.status == 1 ? "待生成" : "生成中" }}
                </div>
                <el-progress
                  style="width: 80%; margin-left: 12px"
                  :text-inside="true"
                  :stroke-width="12"
                  :percentage="scope.row.progress"
                />
              </div>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            label="更多操作"
            width="120"
            prop="action"
          >
            <template #default="scope">
              <el-button type="primary" plain @click="handleCancel(scope.row)"
                >取消生成</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-card>
  </div>
</template>

<script>
import {
  queueList,
  queryVideoWaitNum,
  cancelqueueTask,
} from "@/assets/api/aiProduct";
export default {
  data() {
    return {
      listLoading: false,
      tableList: [],
      sourceMap: new Map(),
      waitNum: 0,
      contNo:0,
      max:5,
      maxTime:3000,
      eventSoure:null
    };
  },
  mounted() {
    this.queryTableList();
    this.init(this.queryTableList())
  },
 beforeDestroy(){
    this.eventSoure && this.eventSoure.close();
     // 监听浏览器界面关闭事件
    window.addEventListener('beforeunload',()=>{
      this.eventSoure && this.eventSoure.close();
    });
 },
  methods: {
    getRandomInt() {
      return Math.floor(Math.random() * 98) + 1;
    },
    /** 查询排队数量 */
    queryNum() {
      queryVideoWaitNum().then((res) => {
        if (res.code === "200") {
          this.waitNum = res.data.waitNum;
        }
      });
    },
    /**
     * 查询表格数据
     */
    queryTableList() {
      return new Promise((resolve, reject) => {
        this.listLoading = true;
        queueList()
          .then((res) => {
            this.listLoading = false;
            if (res.success&&res.data.length) {
              res.data.forEach((items) => {
                const progress =
                  this.sourceMap.get(items.id) + 1 || this.getRandomInt();
                items.progress = items.status == 1 ? 0 : progress;
                if (!this.sourceMap.has(items.id)) {
                  this.sourceMap.set(items.id, progress);
                }
              });
              this.tableList = res.data;
              resolve(res.data);
            } else {
              this.tableList = [];
              resolve([]);
            }
            this.queryNum();
          })
          .catch(() => {
            reject([]);
          });
      });
    },
    /**
     *   取消生成
     */
    handleCancel(row) {
      this.$confirm(`是否确认取消生成视频?`, "温馨提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(async () => {
        cancelqueueTask(row.id).then(async (res) => {
          if (res.success) {
            this.tableList = this.tableList.filter(
              (items) => items.id != row.id
            );
            this.queryNum();
          }
        });
      });
    },
    init(callback){
               const userInfos = localStorage.getItem("store")
               if(!userInfos) return;
                const SLBAdminInfo = userInfos && JSON.parse(userInfos)
                console.log(SLBAdminInfo);
                
                const userId = SLBAdminInfo.user.userId;
                const url = `${process.env.VUE_APP_API}/sse/connect?userId=${userId}`;//连接地址
                this.eventSoure = new EventSource(url);
                this.eventSoure.onopen = (event)=>{
                    console.log('建立SSE链接成功open',this.eventSoure.readyState)
                }
                this.eventSoure.addEventListener("heartbeat", function(e) {
                        console.log('心跳事件正常',this.eventSoure.readyState)
                });
                this.eventSoure.addEventListener("videoRefresh", function(e) {
                        console.log('列表刷新事件',this.eventSoure.readyState)
                         let timer =  setTimeout(()=>{
                           callback && callback();
                           clearTimeout(timer)
                        },2000)
                        
                });
                this.eventSoure.onerror = (event)=>{
                    // ，正在尝试重新连接 ====》
                    console.error('连接错误',event);
                    console.log('报错连接状态',this.eventSoure.readyState,this.eventSoure)
                     
                    // 主动关闭 连接 防止 自动连接
                     this.eventSoure.close();
                     console.log('关闭连接了,关闭的连接状态',this.eventSoure.readyState)
                     connect && connect();
                }
        },
    
        /**
         *  重新建立连接
         */
       connect (){
            console.log('正在尝试重新连接===>',this.contNo)
            if(this.contNo < this.max){
                this.contNo ++;
                const maxTimes = Math.min(1000 * Math.pow(2,this.contNo),this.maxTime);
                setTimeout(()=>{
                   this.init(this.queryTableList());
                },maxTimes)
            }else {
                console.error('已经达到最大连接次数，停止重新连接')
            }
        }
  },
};
</script>

<style scoped>
.searchTitle {
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 10px;
  display: flex;
  align-items: center;
}

.videoCover {
  width: 200px;
  height: 200px;
}

.emptyText {
  color: #acb2c3;
  font-size: 14px;
}
.remarks {
  font-weight: 400;
  font-size: 12px;
  color: #acb2c3;
  text-align: left;
  margin-top: 20px;
  margin-bottom: 30px;
}
.tags-cicle {
  width: 20px;
  height: 20px;
  background: #f65936;
  display: flex;
  align-items: center;
  font-size: 12px;
  color: #ffffff;
  justify-content: center;
  border-radius: 50%;
}
.flex-items {
  display: flex;
  align-items: center;
}
</style>
